import React from 'react';
import VstComponent from './VstComponent';

class VstHeaderButton extends VstComponent {

  render() {
    return (
      <li className="vst-header-button">
        <button {...this.props} className="vst-no-button little-head-button">
          {this.props.children}
        </button>
      </li>
    );
  }

}

export default VstHeaderButton;
